import { useForm } from 'react-hook-form';
import { withTranslation } from 'react-i18next';

import Alert from '../../components/Atoms/Alert';
import Button from '../../components/Atoms/Button';
import ButtonsContainer from '../../components/Atoms/ButtonsContainer';
import Checkbox from '../../components/Atoms/Checkbox';
import Heading from '../../components/Atoms/Heading';

const LanguagesSelectorWindow = ({ t, contentLanguages, interfaceLanguages, currentContentLanguages = [], currentInterfaceLanguage = null, onSubmit = () => { } }) => {
  const experimentalStyle = {
    fontSize: 'var(--font-size-9)',
    lineHeight: 'var(--line-size-6)',
    opacity: 0.7,
    marginLeft: 'var(--space-small)',
  }

  const experimentalTag = <i style={experimentalStyle}>({t('Experimental')})</i>

  const { register, handleSubmit, watch } = useForm({ defaultValues: { contentLanguages: currentContentLanguages, interfaceLanguage: currentInterfaceLanguage } });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Heading h={1} center>
        {t('Choose your languages')}
      </Heading>

      <br />

      <Heading seo={2} h={6}>
        {t('The site will only show content in these languages')}
      </Heading>
      {contentLanguages.map((language) => (
        <Checkbox key={language.value} type="checkbox" title={language.isExperimental ? <>{language.label} {experimentalTag}</> : language.label} value={language.value} register={register('contentLanguages')} />
      ))}

      <br />

      <Heading seo={2} h={6}>
        {t('The site will be displayed using this language')}
      </Heading>
      {interfaceLanguages.map((language) => (
        <Checkbox key={language.value} type="radio" title={language.isExperimental ? <>{language.label} {experimentalTag}</> : language.label} value={language.value} register={register('interfaceLanguage')} />
      ))}

      {interfaceLanguages.filter(e => e.isExperimental).map(e => e.value).includes(watch('interfaceLanguage')) && <>
        <br />
        <Alert type="EXPERIMENTAL" transparent>{t('You are currently using an experimental language. If you notice any translation errors, please let us know via the "Community" tab.')}</Alert>
      </>}

      <br />

      <ButtonsContainer position="CENTER">
        <Button type="submit" form="languages" action={handleSubmit(onSubmit)} label={t('Validate')} />
      </ButtonsContainer>
    </form>
  );
};

export default withTranslation()(LanguagesSelectorWindow);
